"use strict";
/** state: Final **/
/** family: MultiSelect **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Checkbox_1 = require("../Checkbox");
var DropdownButton_1 = require("../DropdownButton");
var MultiSelectCommon_1 = require("../MultiSelectCommon");
var handleCheckboxChange = function (e, current, getSelectedItemsOnSelect, onChange, selectedItems) {
    return onChange(e, getSelectedItemsOnSelect(selectedItems, current), current);
};
/**
 * MultiSelectButtons allow the user to select multiple options,
 * but are useful when space is limited.
 * These are commonly used for filters.
 *
 * Also see {{MultiSelect#MultiSelectList}}.
 */
var MultiSelectButton = function (props) {
    var items = props.items, onChange = props.onChange, restProps = __rest(props, ["items", "onChange"]);
    return (React.createElement(MultiSelectCommon_1.MultiSelectCommon, __assign({}, restProps), function (_a) {
        var getSelectedItemsOnSelect = _a.getSelectedItemsOnSelect, isSelected = _a.isSelected;
        return (items || []).map(function (item, index) { return (React.createElement(DropdownButton_1.DropdownButton.Item, { key: index, role: DropdownButton_1.DropdownButton.Item.Role.Option, onClick: function (e) {
                handleCheckboxChange(e, item, getSelectedItemsOnSelect, onChange, props.selectedItems);
            } },
            React.createElement(Checkbox_1.Checkbox, { label: item.label, checked: isSelected(props.selectedItems, item), value: item.value }))); });
    }));
};
exports.MultiSelectButton = MultiSelectButton;
MultiSelectButton.defaultProps = {
    items: [],
    selectedItems: [],
};
//# sourceMappingURL=MultiSelectButton.js.map